import { AxiosError } from 'axios';
import { useAccountState } from 'contexts/account/account-context';
import { SnackbarActionTypes, useSnackbarDispatch } from 'contexts/snackbar/SnackbarContext';
import { usePost } from 'hooks/use-post';
import { useIntl } from 'react-intl';
import { ErrorMessage } from 'types/shared/error-message.type';
import { putOrder } from 'views/order-feed/features/my-supply-plan/api/orders-api';
import { EditOrderInput, EditOrderResult } from 'views/order-feed/features/my-supply-plan/types/edit-order-input.type';

type UpdateOrderOptions = {
  onSuccess?: (data: EditOrderResult) => void | Promise<void>;
  onError?: (error: AxiosError<ErrorMessage[]>) => void | Promise<void>;
};

export const useUpdateOrder = () => {
  const {
    account: { company },
  } = useAccountState();
  const snackbarDispatch = useSnackbarDispatch();
  const intl = useIntl();

  const updateOrder = usePost<EditOrderResult, { customerErpId: string; data: EditOrderInput }, AxiosError<ErrorMessage[]>>(
    (request) => putOrder(request.customerErpId, request.data),
    () => {
      snackbarDispatch({
        type: SnackbarActionTypes.SUCCESS_SNACKBAR,
        payload: { msg: intl.formatMessage({ id: 'snackbar.success.default' }) },
      });
    },
    (error) => {
      snackbarDispatch({
        type: SnackbarActionTypes.ERROR_SNACKBAR,
        payload: {
          msg: intl.formatMessage({ id: 'snackbar.errors.default' }),
          error: error,
          errorMsg: error.response?.data,
        },
      });
    }
  );

  const handleUpdateOrder = (data: EditOrderInput, options?: UpdateOrderOptions) => {
    if (!company?.customerErpId) return;

    updateOrder.mutate(
      {
        customerErpId: company.customerErpId,
        data,
      },
      {
        onSuccess: options?.onSuccess,
        onError: options?.onError,
      }
    );
  };

  return { handleUpdateOrder, updateOrder };
};
